import React from "react";

const PrivacyPolicy = () => {
  return (
    <div className="privacy-container">
      <div className="overlay"></div>
      
      <div className="content-wrapper">
        <div className="privacy-content">
          {/* Header Section */}
          <header className="privacy-header">
            <h1>Privacy Policy</h1>
            <h2>Privacy Policy for <span className="brand-name">Makemyhouse.Ai</span></h2>
          </header>

          {/* Main Content */}
         <main className="privacy-main">
  {/* Section 1 */}
  <section className="privacy-section">
    <h3>1. Privacy Policy</h3>
    <p>
      Privacy Policy for <strong>Makemyhouse.ai</strong><br />
      Makemyhouse.ai (“we”, “us”, “our”) is committed to protecting your
      privacy. This Privacy Policy explains how we collect, use, disclose,
      and safeguard your personal information when you visit our website
      Makemyhouse.ai (the “Site”) and use our services (“Services”).
      By using the Site or Services, you agree to the collection and use
      of information in accordance with this policy.
    </p>
  </section>

  {/* Section 2 */}
  <section className="privacy-section">
    <h3>2. Information We Collect</h3>
    <div className="subsection">
      <h4>a) Information You Provide:</h4>
      <ul>
        <li>Name, email address, phone number, address</li>
        <li>Details about your project: house plans, style preferences, budget, etc.</li>
        <li>
          Payment information (if you purchase a service) – only what is needed to
          process payment; we do not store full credit card numbers if using
          third-party payment processors.
        </li>
      </ul>
    </div>
    <div className="subsection">
      <h4>b) Automatically Collected Information:</h4>
      <ul>
        <li>Usage data (pages visited, time spent on pages)</li>
        <li>IP address, browser type, device type, operating system</li>
        <li>Cookies, log files, Google Analytics, remarketing pixels (if used)</li>
      </ul>
    </div>
  </section>

  {/* Section 3 */}
  <section className="privacy-section">
    <h3>3. How We Use Your Information</h3>
    <ul>
      <li>Provide, manage, and deliver our Services (architectural planning, consultation, etc.)</li>
      <li>Respond to your inquiries and support requests</li>
      <li>Process payments</li>
      <li>Improve our website and Services</li>
      <li>Send you updates, appointments, marketing/promotional materials (only if you’ve given consent)</li>
      <li>Maintain security and prevent fraud</li>
    </ul>
  </section>

  {/* Section 4 */}
  <section className="privacy-section">
    <h3>4. Disclosure of Your Information</h3>
    <ul>
      <li>With service providers (payment processors, hosting providers, etc.)</li>
      <li>
        With third parties (contractors, architects, consultants) only to the
        extent required to provide the Services
      </li>
      <li>When required by law (court order, government request)</li>
      <li>For fraud prevention and investigation</li>
      <li>With your consent</li>
    </ul>
  </section>

  {/* Section 5 */}
  <section className="privacy-section">
    <h3>5. Cookies and Tracking Technologies</h3>
    <ul>
      <li>We use cookies and similar tracking technologies</li>
      <li>
        You can set your browser to refuse cookies or alert you when cookies are being sent.
        Some parts of the Site may not work properly without cookies.
      </li>
      <li>We may also use Google Analytics, Facebook Pixel (if applicable), or other tools</li>
    </ul>
  </section>

  {/* Section 6 */}
  <section className="privacy-section">
    <h3>6. Data Security</h3>
    <ul>
      <li>We take reasonable administrative, technical, and physical measures to protect your personal information</li>
      <li>No method of transmission or electronic storage is 100% secure</li>
    </ul>
  </section>

  {/* Section 7 */}
  <section className="privacy-section">
    <h3>7. Data Retention</h3>
    <ul>
      <li>We will retain your personal data only as long as needed, unless required by law</li>
      <li>
        If you request deletion, we will erase your personal data unless we must
        keep it for legal obligations, dispute resolution, or enforcement
      </li>
    </ul>
  </section>

  {/* Section 8 */}
  <section className="privacy-section">
    <h3>8. Your Rights</h3>
    <ul>
      <li>You can access, correct, or delete your personal information</li>
      <li>You can withdraw consent if processing is based on consent</li>
      <li>You can object to or restrict processing</li>
      <li>If applicable, you can request data portability</li>
    </ul>
  </section>

  {/* Section 9 */}
  <section className="privacy-section">
    <h3>9. Children’s Privacy</h3>
    <ul>
      <li>Our Services are not directed to children under 18</li>
      <li>We do not knowingly collect data from children under 18</li>
      <li>
        If you believe we have collected data from a child, please contact us to remove it
      </li>
    </ul>
  </section>

  {/* Section 10 */}
  <section className="privacy-section">
    <h3>10. Changes to This Privacy Policy</h3>
    <ul>
      <li>We may update this Privacy Policy from time to time</li>
      <li>
        Updates will be posted with a “Last updated” date on the Site
      </li>
      <li>Continued use after changes means you accept the revised policy</li>
    </ul>
  </section>

  {/* Section 11 */}
  <section className="privacy-section">
    <h3>11. Contact Us</h3>
    <p>
      If you need to reach us for questions about policy, privacy, or services:
    </p>
    <ul>
      <li><strong>Makemyhouse.ai</strong></li>
      <li>Registered Business Name: Masons Mark Private Limited</li>
      <li>Address: 301-302, Corporate House, RNT Marg, Indore, Madhya Pradesh, 452001</li>
      <li>Email: contact@makemyhouse.com</li>
      <li>Phone: +91-731-6803999</li>
    </ul>
  </section>
</main>

        </div>
      </div>

      <style jsx>{`
        .privacy-container {
          position: relative;
          min-height: 100vh;
          background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 800"><rect fill="%23000" width="1200" height="800"/><g fill="%23333"><circle cx="200" cy="150" r="80" opacity="0.1"/><circle cx="800" cy="300" r="120" opacity="0.05"/><circle cx="1000" cy="600" r="100" opacity="0.08"/></g></svg>') center/cover;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 20px;
          font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
        }
        footer {
    display: block !important;
    /* top: 0; */
    bottom: 0;
    width: 100%;
    z-index: 9999;
}
        .overlay {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: linear-gradient(135deg, rgba(0, 0, 0, 0.7) 0%, rgba(0, 0, 0, 0.5) 100%);
          z-index: 1;
        }

       .content-wrapper {
    position: relative;
    z-index: 2;
    width: 100%;
    max-width: 900px;
    max-height: 90vh;
    overflow-y: auto;
    scrollbar-width: thin;
    scrollbar-color: rgb(255 255 255 / 0%) transparent;
}

        .content-wrapper::-webkit-scrollbar {
          width: 6px;
        }

        .content-wrapper::-webkit-scrollbar-track {
          background: rgba(255, 255, 255, 0.1);
          border-radius: 3px;
        }

        .content-wrapper::-webkit-scrollbar-thumb {
          background: rgba(255, 255, 255, 0.3);
          border-radius: 3px;
        }

        .content-wrapper::-webkit-scrollbar-thumb:hover {
          background: rgba(255, 255, 255, 0.5);
        }

        .privacy-content {
          background: rgba(0, 0, 0, 0.9);
          backdrop-filter: blur(10px);
          border-radius: 16px;
          padding: 40px;
          box-shadow: 0 20px 40px rgba(0, 0, 0, 0.5);
          border: 1px solid rgba(255, 255, 255, 0.1);
        }

        .privacy-header {
          text-align: center;
          margin-bottom: 40px;
          border-bottom: 2px solid #4a5568;
          padding-bottom: 30px;
        }

        .privacy-header h1 {
          font-size: 2.5rem;
          font-weight: 700;
          color: #ffffff;
          margin: 0 0 15px 0;
          text-shadow: 0 2px 4px rgba(255, 255, 255, 0.1);
        }

        .privacy-header h2 {
          font-size: 1.25rem;
          font-weight: 500;
          color: #a0aec0;
          margin: 0;
        }

        .brand-name {
          font-weight: 700;
          color: #2d3748;
         background: linear-gradient(135deg, #307f3a 0%, #dddae0 100%);
          -webkit-background-clip: text;
          background-clip: text;
          -webkit-text-fill-color: transparent;
        }

        .privacy-main {
          line-height: 1.7;
          color: #e2e8f0;
        }

        .privacy-section {
          margin-bottom: 35px;
          background: rgba(26, 32, 44, 0.6);
          border-radius: 12px;
          padding: 30px;
          border: 1px solid rgba(113, 128, 150, 0.3);
          transition: all 0.3s ease;
        }

        .privacy-section:hover {
          background: rgba(26, 32, 44, 0.8);
          transform: translateY(-2px);
          box-shadow: 0 8px 25px rgba(0, 0, 0, 0.3);
        }

        .privacy-section h3 {
          font-size: 1.5rem;
          font-weight: 600;
          color: #ffffff;
          margin: 0 0 20px 0;
          border-left: 4px solid #22792d;
          padding-left: 15px;
        }

        .privacy-section p {
          margin: 0 0 15px 0;
          font-size: 1rem;
          color: #cbd5e0;
        }

        .subsection {
          margin: 20px 0;
          padding: 20px;
          background: rgba(45, 55, 72, 0.5);
          border-radius: 8px;
          border: 1px solid rgba(113, 128, 150, 0.2);
        }

        .subsection h4 {
          font-size: 1.1rem;
          font-weight: 600;
          color: #f7fafc;
          margin: 0 0 12px 0;
        }

        ul {
          margin: 0;
          padding: 0 0 0 20px;
          list-style: none;
        }

        ul li {
          margin: 10px 0;
          padding-left: 20px;
          position: relative;
          color: #cbd5e0;
          font-size: 1rem;
        }

        ul li::before {
          content: "•";
          color: #307f3a;
          font-weight: bold;
          position: absolute;
          left: 0;
          font-size: 1.2rem;
        }

        ul li:hover {
          color: #ffffff;
          transform: translateX(3px);
          transition: all 0.2s ease;
        }

        /* Responsive Design */
        @media (max-width: 768px) {
          .privacy-container {
            padding: 10px;
          }

          .privacy-content {
            padding: 25px;
            margin: 10px 0;
          }

          .privacy-header h1 {
            font-size: 2rem;
          }

          .privacy-header h2 {
            font-size: 1.1rem;
          }

          .privacy-section {
            padding: 20px;
            margin-bottom: 25px;
          }

          .privacy-section h3 {
            font-size: 1.3rem;
          }

          .subsection {
            padding: 15px;
          }
        }

        @media (max-width: 480px) {
          .privacy-header h1 {
            font-size: 1.8rem;
          }

          .privacy-header h2 {
            font-size: 1rem;
          }

          .privacy-section h3 {
            font-size: 1.2rem;
          }
        }
      `}</style>
    </div>
  );
};

export default PrivacyPolicy;